export default {
    namespaced: true,

    state: {
        cart: {},
        items: [],
        itemsCount: 0,
        promoCode: '',
        clientId: 0,
        form: {
            items_count: 0,
            delivery_method_id: '',
            payment_type_id: '',
            service_id: '',
            address_id: '',
            address: {
                region: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                city: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                district: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                street: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                house: '',
                zip: '',
                flat: '',
            },
            pickup_point_id: '',
            email: '',
            phone_number: '',
            name: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            subscribe: 1,
            accept: 1,
            comment: '',
            promo_code: '',
            bonus_write_off: 0,
            bonus_movement_type_id: 1,
        },
        errors: false,
        maxAllowedItemsCount: 3,
        availableBonusAmount: 0,
        bonusAccumulationPercentage: 0,
        maxBonusWriteOffPercentage: 0,
        lastAddedItem: false,
        submitting: false,
        addToCartModal: false,
        oneClickOrderModal: false,
        cartErase: false,
        divideOnFourPaymentTypeId: 4,
    },

    getters: {
        bonusAccumulationAmount (state) {
            return state.items.reduce((sum, item) =>
                sum + Math.floor(item.product.step_price * state.bonusAccumulationPercentage / 100) * item.quantity, 0);
        },
        getMaxAllowedItemsCount (state) {
            return state.maxAllowedItemsCount;
        },
        getItemByIndex : state => (index) => {
            return state.items[index];
        },
        activeItems (state) {
            return state.items.filter(item => item.product.status);
        },
        activeItemsCount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator + item.quantity, 0);
        },
        inactiveItemsCount (state) {
            return state.items.filter(item => !item.product.status).length;
        },
        totalPriceWithoutDiscount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator + item.quantity * item.product.price, 0);
        },
        totalDiscount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator
                + (item.product.discount >= item.product.client_card_discount
                        ? Math.ceil(item.product.price * item.product.discount / 100) * item.quantity
                        : 0
                )
                + (item.product.discount_amount * item.quantity), 0);
        },
        clientCardDiscount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator
                + (item.product.discount < item.product.client_card_discount
                        ? Math.ceil(item.product.price * item.product.client_card_discount / 100) * item.quantity
                        : 0
                ), 0);
        },
        promoCodeDiscount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator
                + Math.ceil(item.product.selling_price * item.product.promo_code_discount / 100) * item.quantity
                + (item.product.promo_code_discount_amount * item.quantity), 0);
        },
        bonusDiscount (state, getters) {
            return getters.activeItems.reduce((accumulator, item) => accumulator
                + (item.additional_bonus_discount_amount ? item.additional_bonus_discount_amount : 0)
                + (item.product.bonus_discount_amount * item.quantity), 0)
        },
        totalPrice (state, getters) {
            return getters.totalPriceWithoutDiscount
                - getters.totalDiscount
                - getters.clientCardDiscount
                - getters.promoCodeDiscount
                - getters.bonusDiscount;
        },
        isCourierDelivery (state) {
            return parseInt(state.form.delivery_method_id) === 1;
        },
        isPickupDelivery (state) {
            return parseInt(state.form.delivery_method_id) === 2;
        },
        isPostDelivery (state) {
            return parseInt(state.form.delivery_method_id) === 3;
        },
        isStoreDelivery (state) {
            return parseInt(state.form.delivery_method_id) === 6;
        },
        stepOneValid (state, getters) {
            return (getters.isCourierDelivery && state.form.address_id && state.form.service_id)
                || (getters.isPostDelivery && state.form.address_id && state.form.service_id)
                || ((getters.isPickupDelivery || getters.isStoreDelivery) && state.form.service_id && state.form.pickup_point_id);
        },
        stepTwoValid (state, getters) {
            return getters.stepOneValid && state.form.payment_type_id;
        },
        submittable (state, getters) {
            return getters.stepTwoValid
                && !getters.exceedCountThreshold
                && state.form.first_name
                && state.form.last_name
                && (parseInt(state.form.payment_type_id) === 2 ? state.form.email : true)
                && state.form.phone_number;
        },
        exceedCountThreshold (state, getters) {
            return state.maxAllowedItemsCount < getters.activeItemsCount;
        },
        hasError: (state) => (field) => {
            return  _.has(state.errors, field);
        },
        getError: (state) => (field) => {
            return _.has(state.errors, field) ? _.get(state.errors, field)[0] : '';
        },
        pickupPointLabel: (state, getters, rootState) => {
            if (!state.form.pickup_point_id) {
                return '';
            }

            let pickupPoint = rootState.delivery.pickupPoints.find(
                item => item.id === state.form.pickup_point_id
            );

            return pickupPoint
                ? pickupPoint.name + ' (' + pickupPoint.address + ')'
                : '';
        },
        promoCodeApplied: (state) => {
            return Boolean(state.promoCode);
        },
        productInCart: (state) => (productId) => {
            return _.find(state.cart, (sizes, id) => parseInt(id) === parseInt(productId));
        },
        availableBonusAmount (state) {
            return state.customer ? state.customer.bonus_card_amount : 0;
        }
    },
    mutations: {
        setCart (state, cart) {
            Vue.set(state, 'cart', cart);
        },
        updateCartErase (state, status) {
            Vue.set(state, 'cartErase', !!status);
        },
        updateStatusSubmitting (state, status) {
            Vue.set(state, 'submitting', status);
        },
        setItemsCount (state, count) {
            state.itemsCount = count;
        },
        setItems (state, items) {
            Vue.set(state, 'items', items);
        },
        setLastAddedItem (state, {productId, sizes}) {
            Vue.set(state, 'lastAddedItem', {id: productId, sizes: sizes});
        },
        deleteItem (state, index) {
            state.items.splice(index, 1);
        },
        setItemQuantity (state, { index, quantity }) {
            state.items[index].quantity = quantity;
        },
        setFormValue (state, { key, value, target }) {
            if (_.has(state.errors, key)) {
                Vue.delete(state.errors, key);
            }

            const param = target ? state.form[target] : state.form;

            Vue.set(param, key, value);
        },
        setPromoCode (state, promoCode) {
            Vue.set(state, 'promoCode', promoCode);
            Vue.set(state.form, 'promo_code', promoCode);
        },
        setClientId(state, id) {
            Vue.set(state, 'clientId', id);
        },
        setClientCardDiscount (state, clientCardDiscount) {
            for (let i in state.items) {
                state.items[i].product.client_card_discount = clientCardDiscount;
            }
        },
        setMaxAllowedItemsCount (state, count) {
            state.maxAllowedItemsCount = count;
        },
        setBonusAccumulationPercentage (state, bonusAccumulationPercentage) {
            state.bonusAccumulationPercentage = bonusAccumulationPercentage;
        },
        setMaxBonusWriteOffPercentage (state, maxBonusWriteOffPercentage) {
            state.maxBonusWriteOffPercentage = maxBonusWriteOffPercentage;
        },
        setBonusWriteOff (state, bonusWriteOff) {
            state.form.bonus_write_off = bonusWriteOff;
        },
        setWriteOff (state) {
            const maxBonusWriteOff = state.items.reduce((sum, item) => sum
                + (Math.floor(item.product.step_price * state.maxBonusWriteOffPercentage / 100) * item.quantity), 0);

            state.form.bonus_write_off = state.availableBonusAmount > maxBonusWriteOff
                ? maxBonusWriteOff
                : state.availableBonusAmount;
        },
        setAvailableBonusAmount (state, bonusAmount) {
            state.availableBonusAmount = bonusAmount;
        },
        setErrors (state, errors) {
            Vue.set(state, 'errors', errors);
        },
        clearErrors (state) {
            state.errors = false;
        },
        clearError (state, key) {
            if (_.has(state.errors, key)) {
                Vue.delete(state.errors, key);
            }
        },
        showAddToCartModal(state) {
            state.addToCartModal = true;
        },
        hideAddToCartModal(state) {
            state.addToCartModal = false;
        },
        toggleAddToCartModal(state, status) {
            state.addToCartModal = !!status;
        },
        showOneClickOrderModal(state) {
            state.oneClickOrderModal = true;
        },
        hideOneClickOrderModal(state) {
            state.oneClickOrderModal = false;
        },
        toggleOneClickOrderModal(state, status) {
            state.oneClickOrderModal = !!status;
        },
    },

    actions: {
        addProduct ({ commit, state, getters, rootState }, { productId, sizeRequired, erase = false }) {
            return new Promise((resolve, reject) => {
                const product = rootState.product ? rootState.product.selectedSizes.find(item => item.productId === productId) : null;

                commit('updateCartErase', erase);

                if (sizeRequired && (!product || !product.sizes.length)) {
                    reject({
                        reason: 'no_size_selected'
                    });
                }

                axios.post('/cart', {
                    product_id: productId,
                    sizes: sizeRequired ? product.sizes : [],
                    erase: state.cartErase,
                })
                    .then(response => {
                        commit('setLastAddedItem', {productId: productId, sizes: (sizeRequired ? product.sizes : [])});
                        commit('setItemsCount', response.data.count);
                        commit('setItems', response.data.cartProducts);
                        commit('setMaxAllowedItemsCount', response.data.maxAllowedItemsCount);
                        commit('setPromoCode', response.data.promoCode);
                        commit('updateCartErase', false);

                        let cart = {};
                        _.each(response.data.cartProducts, function (p) {
                            cart[p.product.id] = {};
                            cart[p.product.id][p.size] = p.quantity;
                        });
                        commit('setCart', cart);

                        resolve(response.data);
                    })
                    .catch(error => {
                        if (error.reason === 'no_size_selected') {
                            commit('product/showProductSizeModal', null, { root: true });
                        }

                        reject(error);
                    });
            });
        },

        removeItem ({ commit, state }, index) {
            return new Promise((resolve, reject) => {
                const item = state.items[index];

                axios.delete('/cart', {
                    params: {
                        product_id: item.product.id,
                        size: item.size,
                        phone_number: state.form.phone_number,
                        promo_code: state.form.promo_code,
                    }
                })
                    .then(response => {
                        if (response.data.count === 0) {
                            window.location.reload();
                        } else {
                            commit('setItemsCount', response.data.count);
                            commit('setItems', response.data.products);
                            commit('setPromoCode', response.data.promoCode);
                        }

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        increaseItemQuantity ({ state, dispatch }, index) {
            dispatch('changeItemQuantity', {
                index: index,
                action: 'increase',
                phone_number: state.form.phone_number,
            })
        },

        decreaseItemQuantity ({ state, dispatch }, index) {
            dispatch('changeItemQuantity', {
                index: index,
                action: 'decrease',
                phone_number: state.form.phone_number,
            })
        },

        changeItemQuantity ({ commit, state, dispatch }, { index, action }) {
            commit('setWriteOff');

            return new Promise((resolve, reject) => {
                const item = state.items[index];

                axios.put('/cart', {
                    product_id: item.product.id,
                    size: item.size,
                    action: action,
                    phone_number: state.form.phone_number,
                    bonus_movement_type_id: state.form.bonus_movement_type_id,
                    bonus_write_off: state.form.bonus_write_off,
                    promo_code: state.form.promo_code,
                })
                    .then(response => {
                        commit('setItemsCount', response.data.count);
                        commit('setPromoCode', response.data.promoCode);
                        commit('setItems', response.data.products);
                        commit('setItemQuantity', {
                            index: index,
                            quantity: response.data.quantity
                        });

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);

                        // window.location.reload(true);
                    });
            });
        },

        changeBonusType ({ commit, state, }) {
            return new Promise((resolve, reject) => {
                axios.post('/cart/bonus-type', {
                    bonus_movement_type_id: state.form.bonus_movement_type_id,
                    bonus_write_off: state.form.bonus_write_off,
                    phone_number: state.form.phone_number
                })
                    .then(response => {
                        commit('setItems', response.data.products);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);

                        // window.location.reload(true);
                    });
            });
        },

        setCustomerData ({ commit, state }, customer) {
            for (let key in customer) {
                commit('setFormValue', {
                    key : key,
                    value: customer[key],
                });
                if (customer.id) {
                    commit('setClientId', customer.id);
                }
            }
            if (customer && customer.bonus_card_amount) {
                commit('setAvailableBonusAmount', customer.bonus_card_amount)
            }
            commit('setFormValue', {
                key : 'name',
                value: _.filter([state.form.first_name, state.form.middle_name, state.form.last_name]).join(' '),
            })
        },

        setAddress ({ commit, state, rootGetters }, addressId) {
            let address = rootGetters['customer/getAddressById'](addressId);

            if (address) {
                commit('setFormValue', {
                    key : 'address_id',
                    value: addressId,
                });

                commit('setFormValue', {
                    key : 'address',
                    value: address.form,
                });
            }
        },

        setLocation ({ commit }, location) {
            for (let i in location) {
                commit('setFormValue', {
                    key: i,
                    value: location[i],
                    target: 'address'
                });
            }
        },

        submit ({ commit, getters, state }) {
            return new Promise((resolve, reject) => {
                axios.post('/cart/submit?load', state.form)
                    .then(response => {
                        if (response.data.status === 'success') {
                            if (state.items.length) {
                                let products = state.items.map(item => {
                                    let product = item.product,
                                        category = product.category ? product.category :
                                            (_.has(product.primary_category, 'name') ? product.primary_category.name : product.primary_category),
                                        brand = _.has(product.brand, 'name') ? product.brand.name : product.brand,
                                        name = product.name ? product.name : category + ' ' + brand  + ' ' + product.article;

                                    return {
                                        id: product.id,
                                        name: name,
                                        price: product.final_price ? product.final_price : product.price,
                                        category: category,
                                        brand: brand,
                                        category_ids: product.category_ids,
                                    }
                                });

                                window.events.onCheckout({step: 3, products: products});
                                window.events.onPurchased({order: response.data.order, products: products});
                            }
                            setTimeout(function () {
                                if (response.data.redirectUrl) {
                                    window.location.href = response.data.redirectUrl;
                                }
                            }, 300);
                        } else {
                            commit('updateStatusSubmitting', false);

                            if (response.data.message) {
                                alert(response.data.message);
                            } else {
                                alert('Извините, произошла ошибка. Попробуйте ещё раз позднее или свяжитесь с администратором');
                            }
                        }
                    })
                    .catch(error => {

                        let errors = error.response.data.errors;

                        let steps = [
                            [
                                'items_count',
                            ],
                            [
                                'delivery_method_id',
                                'pickup_point_id',
                                'address.city_id',
                                'address.city_name',
                                'address.house',
                                'address.street.name',
                            ],
                            [
                                'payment_type_id',
                            ],
                            [
                                'first_name',
                                'last_name',
                                'phone_number',
                                'email',
                                'comment',
                            ]
                        ];

                        let filteredErrors = {};
                        for (let step in steps) {
                            if (steps.hasOwnProperty(step) && _.intersection(Object.keys(errors), steps[step]).length) {
                                for (let i in steps[step]) {
                                    if (steps[step].hasOwnProperty(i) && errors[steps[step][i]]) {
                                        filteredErrors[steps[step][i]] = errors[steps[step][i]];
                                    }
                                }
                                break;
                            }
                        }
                        commit('setErrors', filteredErrors);
                        commit('updateStatusSubmitting', false);
                    });
            });
        },

        oneClickSubmit ({ commit, state }) {
            return new Promise((resolve, reject) => {
                axios.post('/order/one-click?load', state.form)
                    .then(response => {
                        if (response.data.status === 'success') {
                            commit('setItemsCount', 0);
                            commit('setItems', []);
                            commit('setPromoCode', '');

                            resolve(response.data);
                        } else {
                            commit('updateStatusSubmitting', false);
                        }
                    })
                    .catch(error => {
                        commit('setErrors', error.response.data.errors);
                        commit('updateStatusSubmitting', false);
                    });
            });
        },

        checkCustomer ({ state, commit, rootState }) {
            if (!rootState.auth.logged) {
                if (!state.form.phone_number) {
                    commit('setClientCardDiscount', 0);

                    return;
                }

                // check for client card by phone_number
                axios.post('/cart/phone-number', {
                    phone_number: state.form.phone_number,
                })
                    .then(response => {
                        if (response.data.status === 'success') {
                            commit('setClientCardDiscount', response.data.clientCardDiscount);
                            commit('setClientId', response.data.clientId);
                            commit('setPromoCode', response.data.promoCode);
                            commit('setAvailableBonusAmount', response.data.bonusCardAmount);
                            commit('setWriteOff');
                        } else {
                            commit('setClientCardDiscount', 0);
                            commit('setClientId', '');
                            commit('setPromoCode', '');
                            commit('setAvailableBonusAmount', 0);
                            commit('setWriteOff');
                        }

                        if (response.data.products) {
                            commit('setItems', response.data.products);
                        }
                    });
            }
        },
    }
}
